export default __webpack_public_path__ + "static/media/DSC_6382-min.7aa2200a.JPG";